import Column from 'components/Layout/Column';
import { CurrencySettings, FundPerformanceData } from '../../types';
import Row from 'components/Layout/Row';
import PerformanceCard from './PerformanceCard';

type Props = {
  currencySettings: CurrencySettings;
  fundPerformance: FundPerformanceData;
  calculatingCurrencyConversions?: boolean;
  showInvestorConvertedCurrency?: boolean;
};

const FundPerformance: React.FC<Props> = ({
  currencySettings,
  fundPerformance,
  calculatingCurrencyConversions,
  showInvestorConvertedCurrency,
}) => {
  const { tvpi, dpi, rvpi, grossMoic, netMoic, grossIrr, netIrr } =
    fundPerformance;
  return (
    <Column spacing="md" fullWidth>
      <Row spacing="md" fullWidth>
        {[
          { label: 'TVPI', ...tvpi },
          { label: 'DPI', ...dpi },
          { label: 'RVPI', ...rvpi },
        ].map((data) => (
          <PerformanceCard
            showInvestorConvertedCurrency={showInvestorConvertedCurrency}
            key={data.label}
            {...data}
            {...currencySettings}
            calculatingCurrencyConversions={calculatingCurrencyConversions}
          />
        ))}
      </Row>
      <Row spacing="md">
        {[
          { label: 'Gross MOIC', ...grossMoic },
          { label: 'Net MOIC', ...netMoic },
          { label: 'Gross IRR', ...grossIrr },
          { label: 'Net IRR', ...netIrr },
        ].map((data) => (
          <PerformanceCard key={data.label} {...data} {...currencySettings} />
        ))}
      </Row>
    </Column>
  );
};

export default FundPerformance;
